module.exports = __webpack_public_path__ + "static/media/182.a9c8abd2.svg";